export class IntegrationFailureModel {
  static fromScoutDTO(date, customFailure) {
    return new IntegrationFailureModel({
      date,
      customFailure: {
        code: customFailure.code,
        param: customFailure.param,
        paramPendingSync: customFailure.paramPendingSync,
        paramLink: undefined
      }
    });
  }
  constructor(data) {
    this.data = data;
  }
  failureCode() {
    return this.data.customFailure.code;
  }
  failureParam() {
    return this.data.customFailure.param;
  }
  invoicesToSync() {
    const {
      paramPendingSync
    } = this.data.customFailure;
    return paramPendingSync ? paramPendingSync.invoicesToSync : [];
  }
  paymentsToSync() {
    const {
      paramPendingSync
    } = this.data.customFailure;
    return paramPendingSync ? paramPendingSync.paymentsToSync : [];
  }
  date() {
    return new Date(this.data.date);
  }
  paramLink() {
    return this.data.customFailure.paramLink;
  }
}